(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-footer"]) return;
  try {
    
const topButton = document.querySelector('.vy-back-top');
if (topButton) {
  const updateTopButton = () => { topButton.hidden = window.scrollY < 500; };
  window.addEventListener('scroll', updateTopButton, { passive: true });
  updateTopButton();
  topButton.addEventListener('click', () => {
    window.scrollTo({top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    document.querySelector('.vy-wordmark')?.focus({preventScroll: true});
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-header"]) return;
  try {
    
import('@shopify/events').then(({StandardEvents})=>document.addEventListener(StandardEvents.cartLinesUpdate,event=>{event.promise?.then(({cart,detail})=>{const count=cart?.totalQuantity??detail?.itemCount;if(count!==undefined)document.querySelectorAll('.vy-bag').forEach(bag=>{bag.querySelector('span').textContent=String(count);bag.setAttribute('aria-label',`Shopping cart, ${count} items`);});}).catch(()=>{});})).catch(()=>{});
document.querySelectorAll('.vy-mobile-menu').forEach(menu=>{menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>menu.removeAttribute('open')));menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.removeAttribute('open');menu.querySelector('summary').focus();}});document.addEventListener('click',e=>{if(!menu.contains(e.target))menu.removeAttribute('open');});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ve-ingredient-list details').forEach(item=>item.addEventListener('toggle',()=>{if(item.open){item.parentElement.querySelectorAll('details').forEach(other=>{if(other!==item)other.open=false;});}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyana-product"]) return;
  try {
    
document.querySelectorAll('[data-vy-step]').forEach(button=>button.addEventListener('click',()=>{const input=button.parentElement.querySelector('input');const step=Number(button.dataset.vyStep);input.value=String(Math.max(1,(parseInt(input.value,10)||1)+step));input.dispatchEvent(new Event('change',{bubbles:true}));}));

  } catch(e) { console.error(e); }
})();
})();
